import type { SearchSnippet, User } from '@aurora/shared-generated/types/graphql-schema-types';
import React from 'react';
import type { ItemType } from '../../../types/enums';
import { UserViewVariant } from '../../../types/enums';
import type { UserSearchViewFragment } from '../../../types/graphql-types';
import type { ItemViewFC } from '../../entities/types';
import mergeVariantProps from '../UserView/UserViewDefaultProps';
import UserViewInline from '../UserView/UserViewInline/UserViewInline';
import type { UserViewCommonProps } from '../UserView/types';

/**
 * Component that renders the user view specified by the <code>variant</code> parameter.
 *
 * @author Deepak Yadav
 */
const UserSearchView: ItemViewFC<UserSearchViewFragment, ItemType.USER_SEARCH, UserViewVariant> = ({
  entity,
  variant = { type: UserViewVariant.INLINE },
  className
}) => {
  const { user } = entity;
  const defaultProps = mergeVariantProps<UserViewCommonProps>(variant);

  return (
    <UserViewInline
      entity={user as User}
      searchSnippet={entity.snippet as SearchSnippet[]}
      className={className}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...{ ...defaultProps, ...variant.props }}
    />
  );
};
export default UserSearchView;
